import React from 'react';
import { 
  FireIcon, 
  ClockIcon, 
  UserGroupIcon, 
  QuestionMarkCircleIcon,
  LightBulbIcon
} from '@heroicons/react/24/outline';

const PlaybookMetrics = ({ metrics }) => {
  const getIcon = (metric) => {
    // Handle old format (type field)
    if (metric.type) {
      switch (metric.type) {
        case 'difficulty':
          return <FireIcon className="h-6 w-6 text-primary-light" />;
        case 'timeline':
          return <ClockIcon className="h-6 w-6 text-primary-light" />;
        case 'size':
          return <UserGroupIcon className="h-6 w-6 text-primary-light" />;
        case 'why':
          return <LightBulbIcon className="h-6 w-6 text-primary-light" />;
        case 'when':
          return <QuestionMarkCircleIcon className="h-6 w-6 text-primary-light" />;
        default:
          return null;
      }
    }

    // Handle new format (label field)
    const labelLower = metric.label?.toLowerCase() || '';
    
    if (labelLower.includes('difficulty')) {
      return <FireIcon className="h-6 w-6 text-primary-light" />;
    }
    if (labelLower.includes('timeline') || labelLower.includes('time')) {
      return <ClockIcon className="h-6 w-6 text-primary-light" />;
    }
    if (labelLower.includes('size') || labelLower.includes('team')) {
      return <UserGroupIcon className="h-6 w-6 text-primary-light" />;
    }
    if (labelLower.includes('why')) {
      return <LightBulbIcon className="h-6 w-6 text-primary-light" />;
    }
    if (labelLower.includes('when') || labelLower.includes('trigger')) {
      return <QuestionMarkCircleIcon className="h-6 w-6 text-primary-light" />;
    }
    return null;
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {metrics.map((metric, index) => (
        <div key={index} className="border border-gray-800 rounded-lg p-4 bg-gray-900/30">
          <div className="flex items-center mb-2">
            {getIcon(metric)}
            <span className="font-semibold ml-2">{metric.label || metric.title}</span>
          </div>
          <p className="text-gray-300">{metric.value}</p>
        </div>
      ))}
    </div>
  );
};

export default PlaybookMetrics; 